import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import CookieBanner from "@/components/CookieBanner";
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import FeedPage from "@/pages/FeedPage";
import TrainerDashboard from "@/pages/TrainerDashboard";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import { TermsPage, PrivacyPage } from "@/pages/LegalPages";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-volt font-heading text-2xl uppercase tracking-widest animate-pulse">
        Loading…
      </div>
    </div>
  );
}

function homeFor(user) {
  return user?.role === "trainer" ? "/dashboard" : "/radar";
}

function Protected({ role, children }) {
  const { user, ready } = useAuth();
  if (!ready) return <Loader />;
  if (!user) return <Navigate to="/auth" replace />;
  if (role && user.role !== role) return <Navigate to={homeFor(user)} replace />;
  return children;
}

function AuthGate() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (user) return <Navigate to={homeFor(user)} replace />;
  return <AuthPage />;
}

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<AuthGate />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/radar" element={<Protected role="fighter"><FeedPage /></Protected>} />
            <Route path="/dashboard" element={<Protected role="trainer"><TrainerDashboard /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
